import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { configureStore } from '@reduxjs/toolkit';
import bearerTokenReducer from './store/reducers/bearerTokenReducer';
import timeReducer from './store/reducers/timeReducer';
import App from './App';
import reportWebVitals from './reportWebVitals';

const store = configureStore({reducer: {
  bearerTokenReducer: bearerTokenReducer,
  timeReducer: timeReducer
}})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <Provider store={store}>
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </Provider>
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();